// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3MHGl","content":"styles_content__1TT-b","selectAll":"styles_selectAll__99nM4"};